import { useFaq } from './usePublicContent';

export const FaqSection = () => {
  const { items } = useFaq();

  return (
  <section id="gyik" aria-labelledby="gyik-cim" className="scroll-mt-24 py-16 sm:py-20">
    <div className="mx-auto w-full max-w-[1220px] px-4 sm:px-6">
      <div className="mx-auto mb-10 max-w-[56ch] text-center">
        <h2 id="gyik-cim" className="text-2xl">
          Gyakori kérdések
        </h2>
        <p className="mt-3 text-ink-soft">
          Ha itt nem találja a választ, hívjon minket – szívesen elmondjuk telefonon is.
        </p>
      </div>

      <div className="mx-auto max-w-[840px]">
        {items.map((item, index) => (
          <details
            key={item.question}
            open={index === 0}
            className="group mb-3 rounded-lg bg-paper px-6 py-5 [&_summary::-webkit-details-marker]:hidden"
          >
            <summary className="flex min-h-11 cursor-pointer list-none items-center justify-between gap-4 font-display text-lg font-bold text-navy">
              {item.question}
              <span
                className="text-2xl leading-none font-normal text-teal-ink group-open:hidden"
                aria-hidden="true"
              >
                +
              </span>
              <span
                className="hidden text-2xl leading-none font-normal text-teal-ink group-open:inline"
                aria-hidden="true"
              >
                –
              </span>
            </summary>
            <p className="mt-3 text-ink-soft">{item.answer}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
  );
};
